import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'teamRole'
})
export class TeamRolePipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        switch (value) {
            case 'orderer':
                return 'Projektauftraggeber';
            case 'customer':
                return 'Projektkunde';
            case 'lead':
                return 'Projektleiter';
            case 'employee':
                return 'Projektmitarbeiter';
            case 'employee_external':
                return 'Externer Projektmitarbeiter';
            case 'lead_external':
                return 'Externer Projektleiter';
            default:
                return value;
        }
    }
}
